var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "w-full" },
    [
      _c(
        "DefaultContentLayout",
        {
          scopedSlots: _vm._u([
            {
              key: "right-side",
              fn: function () {
                return [
                  _c("GroupCollectionFilters", {
                    attrs: {
                      hideManagersFilter: !_vm.isAdmin,
                      userRole: _vm.currentUser.role,
                      userId: _vm.currentUser.id,
                      managerId: _vm.currentManagerId,
                      managerAccessContractorsIds:
                        _vm.managerAccessContractorsIds,
                      companyId: _vm.company.id,
                      filters: _vm.groupFilters,
                    },
                    on: {
                      filtersChanged: _vm.updateFilters,
                      filtersReset: _vm.resetFilters,
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "LoadingOverlay",
            {
              attrs: {
                hasData: _vm.hasData,
                loading: _vm.isLoading,
                spinnerCentered: "",
              },
            },
            [
              _vm.empty
                ? _c(
                    "EmptyListPlaceholder",
                    {
                      attrs: {
                        title: _vm.emptyListPlaceholder,
                        subtitle: _vm.emptyListSubtitle,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "image",
                            fn: function () {
                              return [_c("EmptyListImageGroups")]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        2254743379
                      ),
                    },
                    [
                      _vm.filtersEmpty
                        ? _c("UiButton", {
                            attrs: { size: "xl", buttonText: "Create Group" },
                            on: { click: _vm.toggle },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "icon",
                                  fn: function () {
                                    return [
                                      _c("PlusIcon", {
                                        staticClass:
                                          "text-white fill-current w-4 h-4",
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                                {
                                  key: "hover-icon",
                                  fn: function () {
                                    return [
                                      _c("HoveredIcon", {
                                        staticClass: "w-4 h-4",
                                      }),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              2344035523
                            ),
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : [
                    _c(
                      "ActionPanel",
                      {
                        staticClass: "mb-4",
                        attrs: { total: _vm.paginationConfig.total },
                      },
                      [
                        _c("UiButton", {
                          attrs: { buttonText: "Create Group" },
                          on: { click: _vm.toggle },
                          scopedSlots: _vm._u([
                            {
                              key: "icon",
                              fn: function () {
                                return [
                                  _c("PlusIcon", {
                                    staticClass:
                                      "text-white fill-current w-4 h-4",
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                            {
                              key: "hover-icon",
                              fn: function () {
                                return [
                                  _c("HoveredIcon", { staticClass: "w-4 h-4" }),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                    _vm._l(_vm.groups, function (group) {
                      return _c("GroupCard", {
                        key: group.id,
                        attrs: {
                          group: group,
                          companyId: _vm.company.id,
                          currentUser: _vm.currentUser,
                          name: group.name,
                          groupId: group.id,
                          managers: group.managers,
                          postings: group.postings,
                          contractors: group.contractors,
                          projects: group.projects,
                          skills: group.skills,
                          active: group.active,
                          location: group.location,
                          archived: group.archived,
                          isAdmin: _vm.isAdmin,
                        },
                        on: { refetch: _vm.handleRefetch },
                      })
                    }),
                    !_vm.$apollo.loading
                      ? _c("CardPagination", {
                          attrs: { config: _vm.paginationConfig },
                          on: {
                            "update:config": function ($event) {
                              _vm.paginationConfig = $event
                            },
                          },
                        })
                      : _vm._e(),
                  ],
            ],
            2
          ),
        ],
        1
      ),
      _vm.dialog
        ? _c("GroupModal", {
            attrs: {
              currentUser: _vm.currentUser,
              dialog: _vm.dialog,
              data: _vm.selectedGroup,
              companyId: _vm.company.id,
            },
            on: {
              refetch: _vm.handleRefetch,
              close: function ($event) {
                _vm.dialog = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }